import embla from 'embla';

const selectors = {
  progressBar: '[data-progress-bar]',
}

class ComponentMobileCarousel extends HTMLElement {
  #carousel = null;

  constructor() {
    super();
    
    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    const progress = this.#carousel.scrollProgress();
    const items = this.#carousel.slideNodes();
    const itemCount = items.length;

    const minMapped = 1 / itemCount;
    const maxMapped = 1;

    const mappedProgress = minMapped + (maxMapped - minMapped) * progress;

    this.progressBar?.style.setProperty('--progress', mappedProgress);
  }

  connectedCallback() {
    this.container = this;
    this.center = this.dataset.center === 'true';
    this.progressBar = this.querySelector(selectors.progressBar);
    
    this.#carousel = embla(this.container, {
      loop: false,
      active: false,
      align: this.center ? 'center' : () => 15,
      breakpoints: {
        '(max-width: 800px)': {
          active: true,
        }
      }
    })

    this.#carousel.on('scroll', this.handleScroll);
  }

  disconnectedCallback() {
    this.#carousel.off('scroll', this.handleScroll);
    this.#carousel.destroy();
  }
}

if (!customElements.get('mobile-carousel')) {
  customElements.define('mobile-carousel', ComponentMobileCarousel);
}